<ng-container *ngIf="systems && (dataSource$ | async) as dataSource; else skeleton">
  <lib-block-title
    id="system-title"
    [title]="labels.title">
  </lib-block-title>
  <section
    class="fx-row fx-gap-3 fx-wrap fx-justify-end"
    id="search-system">
    <section
      *ngIf="filterMode === 'all'"
      class="fx-row fx-gap-3"
      [formGroup]="filters">
      <mat-checkbox
        data-testid="mat-checkbox-only-advanced"
        class="body-2"
        formControlName="certified">
        {{ labels.onlyCertified }}
      </mat-checkbox>
      <mat-checkbox
        data-testid="mat-checkbox-only-base"
        class="body-2"
        formControlName="noCertified">
        {{ labels.onlyNotCertified }}
      </mat-checkbox>
    </section>
    <customer-search
      [placeholder]="labels.searchOnTable"
      [query]="query"
      (queryChange)="query$.next($event); paginatorTable.firstPage(); paginatorList.firstPage()">
    </customer-search>
  </section>
  <section
    id="system-table"
    class="tw-w-full overflow-hidden border-1 radius-4 tw-border-grey-100">
    <table
      mat-table
      class="customer-table system-table"
      [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <th
          *matHeaderCellDef
          mat-header-cell>
          {{ labels.systemName }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
          class="!tw-font-base">
          {{ element.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="alerts">
        <th
          *matHeaderCellDef
          mat-header-cell>
          {{ labels.systemAlerts }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
          class="!tw-font-base">
          <lib-alerts-counter
            *ngIf="shouldShowAlertForSystem(element.system); else only4Advanced"
            [system]="element.system"
            [showZeroState]="true"
            [refresh$]="refresh$">
          </lib-alerts-counter>
          <ng-template #only4Advanced>
            <span>N/A</span>
          </ng-template>
        </td>
      </ng-container>
      <ng-container matColumnDef="dailyProductionEnergy">
        <th
          *matHeaderCellDef
          mat-header-cell>
          {{ labels.dailyProductionEnergy }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
          class="!tw-font-base">
          {{ element.dailyProductionEnergy === null ? '---' : element.dailyProductionEnergy | number: '1.0-2' }} kWh
        </td>
      </ng-container>
      <ng-container matColumnDef="totalProductionEnergy">
        <th
          *matHeaderCellDef
          mat-header-cell>
          {{ labels.totalProductionEnergy }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
          class="!tw-font-base">
          {{ element.totalProductionEnergy === null ? '---' : element.totalProductionEnergy | number: '1.0-2' }} kWh
        </td>
      </ng-container>
      <ng-container matColumnDef="system-status">
        <th
          *matHeaderCellDef
          mat-header-cell>
          {{ labels.systemStatus }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
          class="!tw-font-base">
          <lib-plant-card-overview
            *ngIf="{ details: element.updateDetails$ | async }"
            class="p-3 fx-r-row fx-justify-end"
            [labels]="{
              connectedAndUpdated: labels.connectedAndUpdated,
              disconnected: labels.disconnected,
              notUpdated: labels.notUpdated,
              updated: labels.updated,
              hasAlerts: labels.hasAlerts,
            }"
            [notDevices]="true"
            [refresh$]="refresh$"
            [system]="element.system">
          </lib-plant-card-overview>
        </td>
      </ng-container>

      <ng-container matColumnDef="devices">
        <th
          *matHeaderCellDef
          mat-header-cell>
          {{ labels.systemDevices }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
          class="!tw-font-base">
          <lib-plant-card-overview
            *ngIf="{ details: element.updateDetails$ | async }"
            class="p-3 fx-r-row fx-justify-end"
            [labels]="{
              connectedAndUpdated: labels.connectedAndUpdated,
              disconnected: labels.disconnected,
              notUpdated: labels.notUpdated,
              updated: labels.updated,
              hasAlerts: labels.hasAlerts,
            }"
            [notStatus]="true"
            [refresh$]="refresh$"
            [system]="element.system">
          </lib-plant-card-overview>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th
          *matHeaderCellDef
          mat-header-cell>
          <span class="sr-only">Actions</span>
        </th>
        <td
          *matCellDef="let element"
          mat-cell>
          <ng-container
            *ngTemplateOutlet="actionsTemplate; context: {$implicit: element.system, system: element.system}">
          </ng-container>
        </td>
      </ng-container>

      <tr
        *matHeaderRowDef="computedDisplayedColumns"
        mat-header-row>
      </tr>
      <tr
        *matRowDef="let row; columns: computedDisplayedColumns; let odd = odd"
        class="hover"
        mat-row
        [class.bg-grey-100]="odd"
        (click)="navigateToSystem.emit(row.system)">
      </tr>
      <tr
        *matNoDataRow
        class="mat-row">
        <td
          *ngIf="systems.length"
          [attr.colspan]="computedDisplayedColumns.length">
          <div class="fx-center tw-font-medium text-grey-400 no-data">
            {{ labels.noResults }}
          </div>
        </td>
        <td
          *ngIf="systems.length === 0"
          [attr.colspan]="computedDisplayedColumns.length">
          <div class="fx-center tw-font-medium text-grey-400 no-data">
            <ng-content select="[noPlantsTable]"></ng-content>
          </div>
        </td>
      </tr>
    </table>
    <mat-paginator
      #paginatorTable
      class="text-grey-400 border-t-1 border-grey-100 hide-page-size-label"
      aria-label="Select page"
      data-testid="mat-paginator-table"
      [length]="filteredListCount.value"
      [pageSizeOptions]="pageSizeOptions"
      (page)="paginationChange($event)">
    </mat-paginator>
  </section>
  <section
    id="system-list"
    class="tw-border-grey-100 border-1 radius-4">
    <ng-container *ngIf="systems.length">
      <div
        *ngFor="let system of dataSource; let first = first; let odd = odd; trackBy: trackByFn"
        class="tw-flex tw-flex-col tw-p-2 tw-border-grey-100 hover"
        [class.tw-border-t]="!first"
        [class.bg-grey-100]="odd"
        (click)="navigateToSystem.emit(system.system)">
        <section class="fx-justify-between fx-r-row">
          <lib-plant-card-overview
            *ngIf="{ details: system.updateDetails$ | async }"
            class="fx-r-row"
            [labels]="{
              connectedAndUpdated: labels.connectedAndUpdated,
              disconnected: labels.disconnected,
              notUpdated: labels.notUpdated,
              updated: labels.updated,
              hasAlerts: labels.hasAlerts,
            }"
            [notStatus]="true"
            [refresh$]="refresh$"
            [system]="system.system">
          </lib-plant-card-overview>
          <section class="fx-row fx-gap-2 fx-align-center">
            <lib-plant-card-overview
              *ngIf="{ details: system.updateDetails$ | async }"
              [labels]="{
                connectedAndUpdated: labels.connectedAndUpdated,
                disconnected: labels.disconnected,
                notUpdated: labels.notUpdated,
                updated: labels.updated,
                hasAlerts: labels.hasAlerts,
              }"
              [notDevices]="true"
              [refresh$]="refresh$"
              [system]="system.system">
            </lib-plant-card-overview>
            <lib-alerts-counter
              *ngIf="shouldShowAlertForSystem(system.system)"
              [system]="system.system"
              [refresh$]="refresh$"
              [showZeroState]="true">
            </lib-alerts-counter>
          </section>
        </section>
        <div class="fx-col fx-gap-3 p-3 px-1">
          <div class="fx-row fx-g-1 fx-justify-between">
            <div class="tw-font-normal tw-text-base tw-text-grey-400">
              {{ system.name }}
            </div>
          </div>
          <div class="fx-row fx-g-1 fx-justify-between">
            <div class="tw-font-normal tw-text-sm tw-text-grey-300">
              {{ labels.dailyProductionEnergy }}
            </div>
            <div class="tw-font-normal tw-text-sm tw-text-grey-300">
              {{ system.dailyProductionEnergy | number: '1.0-2' }} kWh
            </div>
          </div>
          <div class="fx-row fx-g-1 fx-justify-between">
            <div class="tw-font-normal tw-text-sm tw-text-grey-300">
              {{ labels.totalProductionEnergy }}
            </div>
            <div class="tw-font-normal tw-text-sm tw-text-grey-300">
              {{ system.totalProductionEnergy | number: '1.0-2' }} kWh
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="systems.length === 0">
      <div class="fx-center tw-font-medium text-grey-400 no-data">
        <ng-content select="[noPlantsList]"></ng-content>
      </div>
    </ng-container>
    <ng-container *ngIf="systems.length && dataSource.length === 0">
      <div class="fx-center tw-font-medium text-grey-400 no-data">
        {{ labels.noResults }}
      </div>
    </ng-container>

    <mat-paginator
      #paginatorList
      class="text-grey-400 border-t-1 border-grey-100 hide-page-size-label"
      aria-label="Select page"
      data-testid="mat-paginator-table"
      [length]="filteredListCount.value"
      [pageSizeOptions]="pageSizeOptions"
      (page)="paginationChange($event)">
    </mat-paginator>
  </section>
</ng-container>

<ng-template #skeleton>
  <ion-skeleton-text
    id="system-title"
    animated
    class="w-50 h-14">
  </ion-skeleton-text>
  <section
    id="system-table"
    class="tw-w-full overflow-hidden border-1 tw-rounded tw-border-grey-100 fx-col">
    <div
      *ngFor="let _ of [].constructor(10)"
      class="fx-row fx-align-center fx-justify-between fx-gap-3 border-b-1 border-grey-100 p-1">
      <ion-skeleton-text
        *ngFor="let _ of [].constructor(4)"
        animated
        class="w-6p h-10">
      </ion-skeleton-text>
    </div>
  </section>

  <section
    id="system-list"
    class="tw-border-grey-100 border-1 tw-rounded-lg">
    <div
      *ngFor="let _ of [].constructor(10); let first = first"
      class="tw-flex tw-flex-col tw-p-2 tw-border-grey-100"
      [class.tw-border-t]="!first">
      <div class="tw-flex tw-justify-between tw-align-middle">
        <ion-skeleton-text
          animated
          class="w-50 h-10">
        </ion-skeleton-text>
        <ion-skeleton-text
          animated
          class="w-20 h-15">
        </ion-skeleton-text>
      </div>
      <ion-skeleton-text
        animated
        class="w-50 h-6">
      </ion-skeleton-text>
    </div>
  </section>
</ng-template>
